import * as types from "./actionTypes";

export function setNavigation(navItems) {
    return { type: types.NAVITEMS_SET, navItems }
}

export function setupNavigation(navItems) {
    return function (dispatch) {
        dispatch(setNavigation(navItems));  
    }
}




// WEBPACK FOOTER //
// ./src/redux/actions/navItemsActions.js